import { render, staticRenderFns } from "./IconBtnSoundOn.vue?vue&type=template&id=5006194a&"
import script from "./IconBtnSoundOn.vue?vue&type=script&lang=js&"
export * from "./IconBtnSoundOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports